import { createContext } from 'react';

export const DocumentGridContext = createContext({
    documentGridOptions: {
        showVouchered: false,
        showRejected: false,
    },
    setDocumentGridOptions: (values: any) => {},
});
